// Libraries
var React = require('react');

// Styles
require('./HygieneLinks.scss');

class HygieneLinksModule extends React.Component {
	render() {
		return (		
			<div className={"hygiene-links"}>
				<div className={"hygiene-links__wrapper"}>
					<ul>
						{this.props.data.links.map((item, index) => {   
							return(         
								<li key={index}>
									<a href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noopener noreferrer" : undefined}>{item.caption}</a> 
								</li>); 
						})}
                    </ul>         
				</div>
			</div>
		)
	}
}

module.exports = HygieneLinksModule;


// WEBPACK FOOTER //
// ./src/components/Footer/HygieneLinks/HygieneLinksModule.js